import { Select } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { type DateRange, type Preset, presetRange, PRESET_LABELS } from "@/lib/periods";

interface Props {
  preset: Preset;
  custom: DateRange;
  onChange: (preset: Preset, custom: DateRange) => void;
}

export function PeriodPicker({ preset, custom, onChange }: Props) {
  const range = preset === "custom" ? custom : presetRange(preset);

  return (
    <div className="flex flex-wrap items-end gap-2">
      <label className="block text-xs">
        <span className="mb-1 block text-muted-foreground">기간 프리셋</span>
        <Select
          className="w-32"
          value={preset}
          onChange={(e) => {
            const next = e.target.value as Preset;
            const r = next === "custom" ? custom : presetRange(next);
            onChange(next, r);
          }}
        >
          {(Object.keys(PRESET_LABELS) as Preset[]).map((p) => (
            <option key={p} value={p}>
              {PRESET_LABELS[p]}
            </option>
          ))}
        </Select>
      </label>

      <label className="block text-xs">
        <span className="mb-1 block text-muted-foreground">시작 (KST)</span>
        <Input
          className="w-44"
          type="datetime-local"
          value={range.from.slice(0, 16)}
          disabled={preset !== "custom"}
          onChange={(e) =>
            onChange("custom", {
              ...custom,
              from: e.target.value + ":00+09:00",
            })
          }
        />
      </label>

      <label className="block text-xs">
        <span className="mb-1 block text-muted-foreground">종료 (KST)</span>
        <Input
          className="w-44"
          type="datetime-local"
          value={range.to.slice(0, 16)}
          disabled={preset !== "custom"}
          onChange={(e) =>
            onChange("custom", {
              ...custom,
              to: e.target.value + ":00+09:00",
            })
          }
        />
      </label>

      <div className="ml-auto text-xs text-muted-foreground">
        {range.from.slice(0, 16).replace("T", " ")} ~ {range.to.slice(0, 16).replace("T", " ")}
      </div>
    </div>
  );
}
